<h2 mat-dialog-title class="perse-dialog-title">Manage Shares</h2>
<mat-dialog-content>
    <!-- Meter info - can be added later if needed
    <div class="meter-info">
      <div class="info-row">
        <span class="label">Meter Number:</span>
        <span class="value">{{ meter.meterNumber }}</span>
      </div>
      <div class="info-row">
        <span class="label">Address:</span>
        <span class="value">{{ meter.address }}</span>
      </div>
      <div class="info-row">
        <span class="label">Fuel Type:</span>
        <span class="value">{{ meter.fuelType }}</span>
      </div>
    </div>
    -->

    <div class="mb-4">
      <p class="meter-info">
        Meter Number: <strong>{{ meter.meterNumber }}</strong>
      </p>
      <p class="meter-info">
        Address: <strong>{{ meter.address }}</strong>
      </p>
    </div>

    @if (shares.length > 0) {
      <div class="shares-section">
        <h3 class="section-title">Active Shares ({{ shares.length }})</h3>
        
        <table mat-table [dataSource]="shares" class="shares-table">
          <!-- Share Type Column -->
          <ng-container matColumnDef="shareType">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let share">
              <mat-chip-listbox>
                <mat-chip [class]="getShareTypeClass(share.shareType)">
                  <mat-icon matChipAvatar>{{ getShareTypeIcon(share.shareType) }}</mat-icon>
                  {{ share.shareType | titlecase }}
                </mat-chip>
              </mat-chip-listbox>
            </td>
          </ng-container>

          <!-- Sharee Name Column -->
          <ng-container matColumnDef="shareeName">
            <th mat-header-cell *matHeaderCellDef>Shared With</th>
            <td mat-cell *matCellDef="let share">
              <div class="sharee-name">
                {{ share.shareeName || 'N/A' }}
              </div>
            </td>
          </ng-container>

          <!-- Start Date Column -->
          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef>Start Date</th>
            <td mat-cell *matCellDef="let share">
              {{ formatDate(share.consentStartDate) }}
            </td>
          </ng-container>

          <!-- End Date Column -->
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef>End Date</th>
            <td mat-cell *matCellDef="let share">
              {{ formatDate(share.consentEndDate) }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let share">
              <div class="action-buttons">
                <button 
                  mat-icon-button 
                  color="warn" 
                  (click)="onRevokeShare(share)"
                  matTooltip="Revoke access">
                  <mat-icon>cancel</mat-icon>
                </button>
                <button 
                  *ngIf="share.shareType === 'link'"
                  mat-icon-button 
                  color="primary" 
                  (click)="onCopyLink(share)"
                  matTooltip="Copy link">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    } @else {
      <div class="no-shares">
        <mat-icon class="no-shares-icon">info</mat-icon>
        <p>This meter is not currently shared with anyone.</p>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()">Close</button>
  </mat-dialog-actions>
